import React, {useEffect, useState} from "react";
import {Hub} from "aws-amplify/utils";
import { I18n } from 'aws-amplify/utils';
import { signInWithRedirect } from 'aws-amplify/auth';
import Main from "./Main";
import {
    Authenticator,
    Button,
    Divider,
    Flex,
    Text,
    useAuthenticator,
    useTheme,
    View,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import "./App.css";
import OnboardingService from "./services/onboarding.service";
import {toast, ToastContainer} from "react-toastify";
import BouncingDotsLoader from "./components/Loader/BouncingDotsLoader";
import OobeWrapper from "./components/OobeWrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import { TokenCacheProvider } from "./contexts/TokenCache";
import { isSsoEnabled } from "./nhd-config";

const initialValues = {
  firstname: "",
  surname: "",
  email: "",
  organisation: "",
  telNo: "",
};

export default function App(props) {
  const { tokens } = useTheme();
  const [selectedTab, setSelectedTab] = useState("signin");
  const [loggedIn, setLoggedIn] = useState(true);
  const [requestAccessValues, setRequestAccessValues] = useState(initialValues);
  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log(loggedIn);
  }, [loggedIn]);

    Hub.listen('auth', ({ payload: { event, data } }) => {
        switch (event) {
            case 'signIn':
                console.log('sign in', event, data)
                // this.setState({ user: data})
                break
            case 'signOut':
                console.log('sign out')
                // this.setState({ user: null })
                break
            default:
                console.log('Hub Message: ', event);
        }
    })

  function handleInputChange(e) {
    setRequestAccessValues((values) => ({
      ...values,
      [e.target.name]: e.target.value,
    }));
    setErrorMessage();
  }

  const handleRequestAccess = () => {
    if (
      requestAccessValues.firstname &&
      requestAccessValues.surname &&
      requestAccessValues.email &&
      requestAccessValues.organisation &&
      requestAccessValues.telNo
    ) {
      setLoading(true);
      OnboardingService.onboarding(requestAccessValues)
        .then((response) => {
          setRequestAccessValues(initialValues);
          toast.success(
            `Your request has been submitted. It is currently being reviewed by admin. Once your request has been reviewed, you will receive an email.`,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
          setLoading(false);
        })
        .catch((error) => console.log(error));
    } else {
      setErrorMessage("Please fill in all fields");
    }
  };

  const logout = (cb) => {
    // setLoggedIn(false);
    cb();
  };

  const components = {
    Footer() {
      const { tokens } = useTheme();
      if (loggedIn !== "true") {
        setLoggedIn(false);
      }
      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Text color={tokens.colors.neutral[80]}>
            © Copyright Ontrac 2024. All rights reserved.
          </Text>
        </View>
      );
    },

    SignIn: {
      Header() {
        return (
           <div>
               {isSsoEnabled() && (
                   <Flex direction="column" justifyContent="space-between">
                       <Divider orientation="horizontal"/>
                       <Flex direction="row" justifyContent="center">
                           <Button
                               fontWeight="normal"
                               onClick={() => signInWithRedirect()}
                               variation="primary"
                               textAlign="center"
                           >Login Using NR Active Directory</Button>
                       </Flex>
                       <Text textAlign="center">OR</Text>
                   </Flex>
               )}
           </div>
        )
      },
      Footer() {
        const { toForgotPassword } = useAuthenticator();

        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toForgotPassword}
              size="small"
              variation="link"
              className="resetPassword"
            >
              Reset Password
            </Button>
            <Text
              color={tokens.colors.neutral[80]}
              width="90%"
              fontSize="9px"
              textAlign={"center"}
              margin={"5px auto 10px auto"}
            >
              <FontAwesomeIcon icon={faInfoCircle} className="nav__icon" />
              The Password reset function is for anyone who does not have a
              Network Rail email address. Network Rail password reset will be
              handled via Azure Active Directory.
            </Text>
          </View>
        );
      },
    },
    SignUp: {
    },
    ConfirmSignUp: {
    },
    SetupTOTP: {
    },
    ConfirmSignIn: {
      Header() {
        const { challengeName } = useAuthenticator(({ challengeName }) => [challengeName]);

        if (challengeName === 'EMAIL_OTP') {
          return (
            <>
              <h2 className="amplify-heading amplify-heading--3">Confirm with Email</h2>
            </>
          );
        }

        return (
          <>
            <h2 className="amplify-heading amplify-heading--3">Confirm with Device</h2>
            <p>Enter a code from your authenticator app to continue.</p>
          </>
        );
      },
    },
    ForceNewPassword: {
      Header: () => <h2 className="amplify-heading amplify-heading--3">Change Password</h2>,
    },
    ForgotPassword: {
      Header: () => <h2 className="amplify-heading amplify-heading--3">Reset Password</h2>,
    },
    ConfirmResetPassword: {
      Header() {
        return (
          <>
            <h2 className="amplify-heading amplify-heading--3">Reset Password</h2>
            <p>We've sent you an email. Enter your verification code and choose a new password.</p>
          </>
        );
      },
    },
  };

  const formFields = {
    signIn: {
      username: {
        placeholder: 'Email',
        labelHidden: true,
      },
      password: {
        placeholder: 'Password',
        labelHidden: true,
      },
    },
    forgotPassword: {
      username: {
        placeholder: 'Email',
        labelHidden: true,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        placeholder: "######",
        label: "Enter code"
      }
    },
  };

  I18n.putVocabularies({
    en: {
      // These come from Amplify JS and were presumably never intended to be visible, but Amplify UI exposes them to the user.
      "challengeResponse is required to confirmSignIn": "Please enter your verification code.",
      "username is required to signIn": "Please enter your email address and password.",
      "password is required to signIn": "Please enter your email address and password.",
      "username is required to resetPassword": "Please enter your email address.",

      // This is unhelpful, because you cannot simply "request a new code".
      "Your verification code has expired. Please request a new code.": 'Your verification code has expired. Press "Back to Sign In" to try again.'
    }
  });

  return (
    <div>
      <div role="banner">
        <h1
          style={{
            display: loggedIn ? "none" : "flex",
            justifyContent: "center",
            margin: "2rem 0",
          }}
        >
          <img
            className="formWidth"
            alt="Network Rail"
            src="/img/network-rail-logo.svg"
          />
        </h1>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          role="navigation"
          className="formWidth"
          style={{
            display: loggedIn ? "none" : "flex",
            placeSelf: "center",
            border: "1px solid hsl(210, 8%, 55%)",
            borderBottom: "none",
          }}
        >
          <button
            style={{
              flex: "1",
              textAlign: "center",
              fontSize: "1rem",
              fontWeight: "700",
              padding: "0.75rem",
              background: "none",
              border: "none",
              borderTop: selectedTab === "signin" ? "1px solid red" : "none",
              cursor: "pointer",
            }}
            onClick={(e) => setSelectedTab("signin")}
          >
            Sign in
          </button>
          <button
            style={{
              flex: "1",
              textAlign: "center",
              fontSize: "1rem",
              fontWeight: "700",
              padding: "0.75rem",
              background: "none",
              border: "none",
              borderTop: selectedTab !== "signin" ? "1px solid red" : "none",
              cursor: "pointer",
            }}
            onClick={(e) => setSelectedTab("requestaccess")}
          >
            Request Access
          </button>
        </div>
        {selectedTab === "signin" ? (
          <div {...(loggedIn ? {} : {role: "main", className: "formWidth", style: {placeSelf: "center"}})}>
            <Authenticator
              components={components}
              formFields={formFields}
              hideSignUp={true}
            >
              {({ signOut, user }) => {
                return (
                  <TokenCacheProvider>
                    <OobeWrapper setLoggedIn={setLoggedIn} signOut={signOut} user={user}>
                      <Main
                        setLoggedIn={setLoggedIn}
                        signOut={() => logout(signOut)}
                        user={user}
                        navigateTo="/smmdashboard"
                      />
                    </OobeWrapper>
                  </TokenCacheProvider>
                );
              }}
            </Authenticator>
          </div>
        ) : (
          <div
            role="main"
            className="formWidth"
            style={{
              display: "flex",

              placeSelf: "center",
              border: "1px solid hsl(210, 8%, 55%)",
              borderTop: "none",
              padding: "2.0rem",
              boxSizing: "border-box",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <input
              className="amplify-input"
              type="text"
              placeholder="First Name"
              name="firstname"
              onChange={handleInputChange}
              value={requestAccessValues.firstname}
              autoComplete="given-name"
            />
            <input
              className="amplify-input"
              type="text"
              placeholder="Surname"
              name="surname"
              onChange={handleInputChange}
              value={requestAccessValues.surname}
              autoComplete="family-name"
            />
            <input
              className="amplify-input"
              type="text"
              placeholder="Email"
              name="email"
              onChange={handleInputChange}
              value={requestAccessValues.email}
              autoComplete="email"
            />
            <input
              className="amplify-input"
              type="text"
              placeholder="Organisation"
              name="organisation"
              onChange={handleInputChange}
              value={requestAccessValues.organisation}
              autoComplete="organization"
            />
            <input
              className="amplify-input"
              type="text"
              placeholder="Telephone Number"
              name="telNo"
              onChange={handleInputChange}
              value={requestAccessValues.telNo}
              autoComplete="tel"
            />
            {!loading ? (
              <button
                className="amplify-button amplify-field-group__control amplify-button--primary amplify-button--fullwidth"
                type="submit"
                onClick={handleRequestAccess}
              >
                Request Access
              </button>
            ) : (
              <BouncingDotsLoader style={{ marginTop: "15px" }} />
            )}
            <div className="form-error">
              {errorMessage && (
                <div className="form-error">
                  <span className="input__error">{errorMessage}</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <ToastContainer />
    </div>
  );
}
